<template>
  <!-- 新闻内容 -->
  <div class="news_cont_zong">
    <div class="item2">
      <div class="item2_cont">
        <div
          class="item2_cont1"
          v-for="(item, index) in arrList"
          :key="index"
          @click="funUrl(index)"
        >
          <img :src="item.url" alt="" />
          <div class="item2_cont1_text">
            <div class="item2_cont1_text_top">
              <h1>
                {{ item.h1 }}
              </h1>
              <p>
                {{ item.p1 }}
              </p>
            </div>
            <div class="item2_cont1_text_btm">
              <div>2021/6/05</div>
              <p>查看更多></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <pagination :total="total" :allPage="allpage" v-on:change="changePage"></pagination>
  </div>
</template>
<script>
import pagination from "../../components/pagination.vue";
export default {
  components: {
		pagination
	},
  data() {
    return {
      allpage: 0,  //总记录数
			size: 10,    //每页显示个数
			current: 0,  //当前显示页
			total: 0,   //总数
      arrList: [
        {
         
          url: require("../../assets/img/xinwen_img.jpg"),
          h1: "电力巡检：保障电力设备安全运行的重要措施",
          p1: "电力巡检是电力运行管理的重要环节，它不仅能够保证电力系统的正常运行，同时也可以避免电力事故的发生。在电力系统中，由于设备长期运行，受到环境因素和使用过程中的损耗等因素的影响，设备可能会出现老化、磨损、松动等问题，如果不及时检查和处理，就会给电力系统带来安全隐患。因此，对于电力巡检，我们必须高度重视。",
        },
        {
         
          url: require("../../assets/img/xinwen_img.jpg"),
          h1: "电力巡检：保障电力设备安全运行的重要措施",
          p1: "电力巡检是电力运行管理的重要环节，它不仅能够保证电力系统的正常运行，同时也可以避免电力事故的发生。在电力系统中，由于设备长期运行，受到环境因素和使用过程中的损耗等因素的影响，设备可能会出现老化、磨损、松动等问题，如果不及时检查和处理，就会给电力系统带来安全隐患。因此，对于电力巡检，我们必须高度重视。",
        },
        {
         
          url: require("../../assets/img/xinwen_img.jpg"),
          h1: "电力巡检：保障电力设备安全运行的重要措施",
          p1: "电力巡检是电力运行管理的重要环节，它不仅能够保证电力系统的正常运行，同时也可以避免电力事故的发生。在电力系统中，由于设备长期运行，受到环境因素和使用过程中的损耗等因素的影响，设备可能会出现老化、磨损、松动等问题，如果不及时检查和处理，就会给电力系统带来安全隐患。因此，对于电力巡检，我们必须高度重视。",
        },
        {
        
          url: require("../../assets/img/xinwen_img.jpg"),
          h1: "电力巡检：保障电力设备安全运行的重要措施",
          p1: "电力巡检是电力运行管理的重要环节，它不仅能够保证电力系统的正常运行，同时也可以避免电力事故的发生。在电力系统中，由于设备长期运行，受到环境因素和使用过程中的损耗等因素的影响，设备可能会出现老化、磨损、松动等问题，如果不及时检查和处理，就会给电力系统带来安全隐患。因此，对于电力巡检，我们必须高度重视。",
        },
        {
   
          url: require("../../assets/img/xinwen_img.jpg"),
          h1: "电力巡检：保障电力设备安全运行的重要措施",
          p1: "电力巡检是电力运行管理的重要环节，它不仅能够保证电力系统的正常运行，同时也可以避免电力事故的发生。在电力系统中，由于设备长期运行，受到环境因素和使用过程中的损耗等因素的影响，设备可能会出现老化、磨损、松动等问题，如果不及时检查和处理，就会给电力系统带来安全隐患。因此，对于电力巡检，我们必须高度重视。",
        },
      ],
    };
  },
  created(){
      this.allpage = 29;
      //总页数
      this.total = 3;
  },
  methods: {
    funUrl(index) {
      if (index < 3) {
        this.$router.push("/newsDetails?id=" + index);
      } else {
        alert("页面未创建无法跳转");
      }
    },
    
    changePage:function(index){
      this.current = index;
      // this.getList();
    },
  },
};
</script>

<style scoped>
/* 新闻列表 */
.item_cont {
  width: 1400px;
  margin: 0 auto;
  margin-top: 40px;
}
.item2_cont1 {
  display: flex;
  width: 1400px;
  height: 252px;
  background: #ffffff;
  box-shadow: 3px 3px 10px 0px rgba(0, 0, 0, 0.11);
  margin-bottom: 30px;
}
.item2_cont1:hover {
  background: #f8f8f8;
  box-shadow: 3px 3px 10px 0px rgba(0, 0, 0, 0.11);
  cursor: pointer;
}

.item_cont1 img {
  margin: 32px 48px 32px 32px;
  width: 300px;
  height: 188px;
  border: dashed;
}
.item_cont1_text {
  width: 868px;
}
.item_cont1_text_top {
  margin: 45px 0 16px 0;
  width: 732px;
  height: 112px;

  border-bottom: 1px solid #eaeaea;
}
.item_cont1_text_top > h1 {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #23337f;
  line-height: 24px;
}
.item_cont1_text_top p {
  margin-top: 16px;
  width: 732px;
  height: 56px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
}
.item_cont1_text_btm {
  width: 732px;

  display: flex;
  justify-content: space-between;
}
.item_cont1_text_btm div {
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #23337f;
  line-height: 28px;
}
.item_cont1_text_btm p {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #23337f;
  line-height: 28px;
}
/* item2 */
.item2_cont {
  width: 1400px;
  margin: 0 auto;
  margin-top: 40px;
  margin-bottom: 30px;
}

.item2_cont1 img {
  margin: 32px 48px 32px 32px;
  width: 300px;
  height: 188px;
}
.item2_cont1_text {
  flex: 1;
}
.item2_cont1_text_top {
  margin: 45px 0 16px 0;
  width: 100%;
  height: 112px;
  padding-right: 32px;
  border-bottom: 1px solid #eaeaea;
}
.item2_cont1_text_top > h1 {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: bold;
  color: #3f3f3f;
  line-height: 24px;
}
.item2_cont1_text_top p {
  margin-top: 16px;
  width: 100%;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item2_cont1_text_btm {
  width: 100%;
  padding-right: 32px;
  display: flex;
  justify-content: space-between;
}
.item2_cont1_text_btm div {
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;

  color: #999999;
  line-height: 28px;
}
.item2_cont1_text_btm p {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #0096a3;
  line-height: 28px;
}
</style>